module.exports = __webpack_public_path__ + "static/Predoc-hero-42166ba0d03a23c80915ebf0dbd2996f.png";